export default "__VITE_ASSET__CBYenz$g__"